import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft, Rocket } from 'lucide-react';

const ComingSoon = ({ title }) => {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-4 grid-pattern" data-testid="coming-soon-page">
      <Card className="w-full max-w-md border-2">
        <CardContent className="pt-8 text-center">
          <div className="mx-auto w-20 h-20 bg-chassis rounded-full flex items-center justify-center mb-6">
            <Rocket className="h-10 w-10 text-electric" />
          </div>
          <h1 className="font-chivo text-3xl font-black uppercase tracking-tight mb-2">{title}</h1>
          <p className="font-mono text-sm text-electric uppercase tracking-widest mb-6">Coming Soon</p>
          <p className="text-muted-foreground mb-8">
            We're working hard to bring you this feature. Stay tuned for updates!
          </p>
          <Link to="/articles">
            <Button variant="outline" className="font-bold uppercase tracking-wider">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Articles
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComingSoon;
